import { Alert, Button, FormControl, Grid, TextField } from "@mui/material";
import { AyudantiaInvestigacionData, CastSolicitudAyudantiaRechazo, solicitudAprobacionDTO } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { useFormik } from "formik";
import {  RechzarMultipleValidate } from "../ValidationForm/validationForm";
import { useState } from "react";
import { useAppSelector } from "../../redux/hooks";
import AyudantiaService from "../../services/AyudantiaService";
import AlertService from "../../services/AlertService";


interface Props{
    token: any,
    data: Array<AyudantiaInvestigacionData>,
    onResponse?: (dataRespuesta: any) => void,
    onClose: () => void,
    tipoPersona: string,
    aceptar : boolean
}

const ayudantiaService = new AyudantiaService();
const alertaService = new AlertService();
export const AccionMultipleForm: React.FC<Props> = ({data, token, onResponse, onClose, tipoPersona, aceptar}) => {
    const { userData } = useAppSelector((state) => state.authReducer);
    const [mensajes, setMensajes] = useState<Array<string>>([]);
    const [tipoBtnPresionado, setTipoBtnPresionado] = useState("");
    const formik = useFormik({
        initialValues :{
            comentario: ''
        },
        validationSchema : aceptar ? null : RechzarMultipleValidate,
        onSubmit: async (values) =>{
            onClose();
            let solicitudes = CastSolicitudAyudantiaRechazo(data,values.comentario);

            if(tipoBtnPresionado ==="A"){
                alertaService.showLoading("procesando...");
                GuardarSolicitudesAceptadas(solicitudes);

            }else{
                alertaService.showLoading("procesando...");
                GuardarSolicitudesRechazadas(solicitudes);
            }
        }
    });


    const GuardarSolicitudesRechazadas = async ( solicitudes : Array<solicitudAprobacionDTO>)=>{
        try{
            setMensajes([]);
            //let tipoPersona = userData.roles.find(x=>x.idrol == 151) ? 'S':'';
            await ayudantiaService.RechazarSolicitudMultiple(token,solicitudes,userData.idpersona,tipoPersona)
            .then((response)=>{
                if(response.status.isSuccessfully){
                    if(onResponse){
                        onResponse(response);
                    }else{
                        console.error('La función onResponse no está definida.')
                    }
                }else{
                    setMensajes(response.status.messages);
                    //alertaService.hideLoading();
                    alertaService.alertaAdvertenciaList('Alerta', response.status.messages[0].split('|').filter((msg: string) => msg.trim() !== ''));
                }
            }).catch((error) => {
                console.error(error)
            });


        }catch(error){
            console.error('Error:',error)
        }
    }

    const GuardarSolicitudesAceptadas = async ( solicitudes : Array<solicitudAprobacionDTO>)=>{
        try{
            setMensajes([]);
            //let tipoPersona = userData.roles.find(x=>x.idrol == 151) ? 'S':'';
            await ayudantiaService.AprobarSolicitudMultiple(token,solicitudes,userData.idpersona,tipoPersona)
            .then((response)=>{
                if(response.status.isSuccessfully){
                    if(onResponse){
                        onResponse(response);
                    }else{
                        console.error('La función onResponse no está definida.')
                    }
                }else{
                    setMensajes(response.status.messages);
                    //alertaService.hideLoading();
                    alertaService.alertaAdvertenciaList('Alerta', response.status.messages[0].split('|').filter((msg: string) => msg.trim() !== ''));
                }
            }).catch((error) => {
                console.error(error)
            });


        }catch(error){
            console.error('Error:',error)
        }
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2} >
                <Grid item xs={12}>
                    <FormControl sx={{m:1}} fullWidth error={Boolean(formik.errors.comentario && formik.touched.comentario)}>
                        <TextField
                            fullWidth
                            id="comentario"
                            name="comentario"
                            label="Comentario"
                            value={formik.values.comentario}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error ={formik.touched.comentario && Boolean(formik.errors.comentario)}
                        />
                        {formik.touched.comentario && formik.errors.comentario && (
                            <Alert severity="error">{formik.errors.comentario}</Alert>
                        )}
                    </FormControl>
                </Grid>

                {
                    aceptar ?
                    <Grid item xs={12}>
                        <Button 
                            size="small"
                            variant="contained"
                            sx={{
                                marginRight: 1, backgroundColor: "#4CAF50",
                            color: "#FFFFFF !important",
                            "&:hover": { backgroundColor: "#81C784" },
                            boxShadow: 3, margin: "10px"
                            }}
                            type='submit'
                            onClick={() => setTipoBtnPresionado("A")}
                            >
                            Aceptar
                        </Button>

                    </Grid>
                    :
                    <Grid item xs={12}>
                        <Button 
                            size="small"
                            variant="contained"
                            sx={{
                                marginRight: 1, backgroundColor: "#F44336",
                                color: "#FFFFFF !important",
                                "&:hover": { backgroundColor: "#E57373" },
                                boxShadow: 3,
                            }}
                            type='submit'
                            onClick={() => setTipoBtnPresionado("R")}
                            >
                            Rechazar
                        </Button>

                    </Grid>

                }

                
            </Grid>
        </form>
    )
}